<button
  type="button"
  [class]="
    'flex flex-col w-full text-left transition-colors cursor-pointer gap-(--notification-card-gap) px-(--notification-card-padding-x) py-(--notification-card-padding-y) bg-(--notification-card-background) rounded-(--notification-card-border-radius) hover:bg-(--notification-card-hover-background) ' +
    (config().shadow ? 'shadow-(--notification-card-shadow) ' : '') +
    (config().border
      ? 'border-(length:--notification-card-border-width,var(--border-width-xs)) border-solid border-(--notification-card-border-color)'
      : '')
  "
  [disabled]="disabled()"
  (click)="onCardClick()"
>
  <div class="flex items-center w-full">
    @if (config().chip) {
      <app-dynamic
        componentName="Chip"
        [props]="{ config: config().chip }"
      />
    }
    <div
      class="ml-auto"
      (click)="$event.stopPropagation()"
    >
      <app-dynamic
        componentName="IconButton"
        [props]="{ config: { icon: 'x', size: 'sm', border: false } }"
        (action)="onDismiss()"
      />
    </div>
  </div>

  <div class="flex items-center gap-4 w-full">
    @if (config().leadingImage) {
      <img
        [src]="config().leadingImage"
        alt=""
        class="w-18 h-18 shrink-0 object-cover rounded-(--notification-card-image-border-radius)"
      />
    }

    <div class="flex-1 flex flex-col gap-1 min-w-0">
      <app-dynamic
        componentName="DynamicText"
        [props]="{ config: titleConfig() }"
      />
      @if (config().supportingText) {
        <app-dynamic
          componentName="DynamicText"
          [props]="{ config: supportingTextConfig() }"
        />
      }
    </div>

    @if (config().showChevron) {
      <app-dynamic
        componentName="SvgIcon"
        [props]="{ name: 'caret-right', size: '16', color: 'var(--notification-card-chevron-color)' }"
        class="shrink-0"
      />
    }
  </div>
</button>
